import React from "react";

const VerticalPlayerCollapseCloseIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="45"
    viewBox="0 0 45 45"
    {...props}
  >
    <rect width="45" height="45" rx="22.5" fill="#fff" stroke="#e4e4e4" />
    <path
      d="M14.271,12.353l6.716-6.716,1.919,1.919L16.19,14.271l6.716,6.716-1.919,1.919L14.271,16.19,7.556,22.906,5.637,20.987l6.716-6.716L5.637,7.556,7.556,5.637Z"
      transform="translate(8.229 8.229)"
      fill="#181818"
    />
  </svg>
);

export default VerticalPlayerCollapseCloseIcon;
